export default __webpack_public_path__ + "static/media/contact-card-2.9cd0f0f1.svg";